export default function HeroSection() {
  const cards = [
    { color: '#d4c5b9', rotate: -12, z: 0, label: 'Architecture' },
    { color: '#c8d6cc', rotate: -6, z: 10, label: 'Performance' },
    { color: '#e8e2d9', rotate: 0, z: 20, label: 'Quality' },
    { color: '#d9d6d1', rotate: 6, z: 10, label: 'Innovation' },
    { color: '#f0ede8', rotate: 12, z: 0, label: 'Stability' },
  ];

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 md:px-6 py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 25% 25%, oklch(var(--foreground-900)) 1px, transparent 1px), radial-gradient(circle at 75% 75%, oklch(var(--foreground-900)) 1px, transparent 1px)',
        backgroundSize: '60px 60px',
      }} />

      <div className="relative z-10 w-full max-w-[1140px] mx-auto flex flex-col items-center">
        <h1 className="font-label text-2xl md:text-3xl font-medium tracking-[0.04em] text-foreground-900 mb-8 whitespace-nowrap">
          DARIUS DIGITAL, MB
        </h1>

        <div className="flex items-center gap-4 md:gap-6 mb-16">
          <span className="w-8 h-[1px] bg-foreground-300" />
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full border border-foreground-400" />
            <span className="w-1 h-1 rounded-full bg-foreground-500" />
            <span className="w-3 h-3 rounded-full border border-foreground-400" />
          </div>
          <span className="w-8 h-[1px] bg-foreground-300" />
        </div>

        <div className="relative w-full flex items-center justify-center mb-16" style={{ perspective: '800px', height: '220px' }}>
          <div className="relative flex items-center justify-center w-full h-full" style={{ transformStyle: 'preserve-3d' }}>
            {cards.map((card, i) => (
              <div
                key={i}
                className="absolute w-[160px] md:w-[200px] h-[180px] md:h-[210px]"
                style={{
                  transform: `translateX(${(i - 2) * 130}px) rotateY(${card.rotate}deg) translateZ(${card.z}px)`,
                  zIndex: 10 - Math.abs(i - 2),
                }}
              >
                <div
                  className="w-full h-full rounded-[20px]"
                  style={{
                    background: card.color,
                    boxShadow: '0px 12px 32px rgba(0,0,0,0.08)',
                  }}
                >
                  <div className="absolute bottom-0 left-0 right-0 bg-white/80 rounded-b-[20px] px-4 py-3">
                    <p className="font-label text-xs font-medium tracking-[0.06em] uppercase text-foreground-700">{card.label}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-foreground-600 text-base md:text-lg max-w-[640px] leading-relaxed font-body">
          A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.
        </p>
      </div>
    </section>
  );
}